export default __webpack_public_path__ + "static/media/wholesale.896f80e4.svg";